import { DatePicker, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import svg from "../../../../Assets/svg";
import dayjs from "dayjs";
import {
  ButtonWithLoader,
  PageLoader,
} from "../../../../Components/Components";
import { useDispatch } from "react-redux";
import {
  AddQuestionAPI,
  AddQuizAPI,
  EditQuizAPI,
  GetQuizzesAPI,
} from "../../../Redux/quiz";

const CreateQuizModal = ({ isModalOpen, onClose, quizId, onCreate }) => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [description, setDescription] = useState("");

  const [fetching, setFetching] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const fetchQuizDetails = async () => {
    setFetching(true);
    const result = await dispatch(
      GetQuizzesAPI({
        id: quizId,
      })
    );
    if (result?.success) {
      // setTotalCount(result.data.total);
      const quizDetails = result.data.data[0];
      setTitle(quizDetails?.title ? quizDetails?.title : "");
      setSelectedDate(dayjs(quizDetails.published_on));
      setDescription(quizDetails?.description ? quizDetails?.description : "");
    }
    setFetching(false);
  };

  useEffect(() => {
    if (quizId) {
      fetchQuizDetails();
    }
  }, [quizId]);

  const handleSave = () => {
    if (!title.trim()) {
      message.error("Title is required!");
      return;
    }
    if (!selectedDate) {
      message.error("Date is required!");
      return;
    }
    if (!description.trim()) {
      message.error("Description is required!");
      return;
    }

    const payload = {
      ...(quizId ? { quiz_id: quizId } : {}),
      title: title,
      description: description,
      published_on: selectedDate,
    };

    setIsSaving(true);

    if (quizId) {
      dispatch(
        EditQuizAPI(
          payload,
          () => {
            setIsSaving(false);
            onClose(true);
          },
          () => {
            setIsSaving(false);
          }
        )
      );
    } else {
      dispatch(
        AddQuizAPI(
          payload,
          (id) => {
            setIsSaving(false);
            onCreate(id);
          },
          () => {
            setIsSaving(false);
          }
        )
      );
    }
  };

  return (
    <Modal
      title={
        <div className="modal-header border-bottom pb-2 fw-bold fs-4 ff">
          {quizId ? "Edit Quiz" : "Create Quiz"}
        </div>
      }
      open={isModalOpen}
      onCancel={() => {
        document.body.classList.remove("modal-open-body");  // Remove class on cancel
        onClose(); // Your existing close logic
      }}
      afterClose={() => {
        document.body.classList.remove("modal-open-body");  // Ensure removal after modal animation closes
      }}
      afterOpenChange={(open) => {
        if (open) {
          document.body.classList.add("modal-open-body");  // Add class when modal opens
        } else {
          document.body.classList.remove("modal-open-body"); // Remove class when modal closes
        }
      }}
      footer={
        fetching ? null : (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <ButtonWithLoader
              className="btn btn-primary btn-lg ku-btn px-4 ff"
              onClick={handleSave}
              isLoading={isSaving}
            >
              {quizId ? "Save" : "Continue & Save As Draft"}
            </ButtonWithLoader>
          </div>
        )
      }
      centered
      closeIcon={svg?.modalClose}
      className="custom-modal"
      width={"67.5rem"}
      maskClosable={false}
    >
      {fetching ? (
        <div className="d-flex justify-content-center align-items-center px-5 py-5">
          <PageLoader />
        </div>
      ) : (
        <div className="d-flex flex-column">
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-1">
              <label className="form-label mb-0 fw-bold ff">Title</label>
              <span className="text-muted lh-0 fs-12">
                {title ? title?.length : 0}/100
              </span>
            </div>
            <input
              maxLength={100}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter Title"
              className="form-control form-control-lg"
            />
          </div>
          <div className="mb-4">
            <label className="form-label mb-1 fw-bold ff">Published On</label>
            <DatePicker
              value={selectedDate ? dayjs(selectedDate) : null}
              // showNow={false}
              onChange={(date) => {
                const formattedDate = date
                  ? dayjs(date).format("YYYY-MM-DD")
                  : null;
                setSelectedDate(formattedDate);
              }}
              suffixIcon={<span className="svg-20">{svg?.calendarIcon}</span>}
              placeholder="Select date"
              className="custom-datepicker form-control form-control-lg w-100"
              format={"MM-DD-YYYY"}
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
            />
          </div>
          <div>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <label className="form-label mb-0 fw-bold ff">Description</label>
              <span className="text-muted lh-0 fs-12">
                {description ? description?.length : 0}/300
              </span>
            </div>
            <textarea
              maxLength={300}
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter Description"
              className="form-control form-control-lg"
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CreateQuizModal;
